var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_917_102663)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_917_102663",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_917_102663)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_917_102663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3104 83C24.3104 83 28.3091 78.3838 75 78.2976C121.691 78.3839 125.69 83 125.69 83C128.473 77.2622 127.963 72.9912 127.963 72.9912C120.044 64.2766 75 66.1748 75 66.1748C75 66.1748 29.9164 64.2766 22.0366 72.9912C22.0366 72.9912 23.5 77 24.3104 83Z",
    fill: "#5D82B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3543 76.0927C65.6517 75.3903 22.0117 72.9756 22.0117 72.9756L33.251 195.817C40.539 206.574 75.3543 204.774 75.3543 204.774C75.3543 204.774 110.17 206.574 117.458 195.817L128.697 72.9756C128.697 72.9756 85.057 75.3903 75.3543 76.0927Z",
    fill: "#93BAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3543 76.0927L22.0117 72.9756L23.1971 85.8393L28.9924 86.9808C29.9582 87.2881 30.6168 88.1662 30.7485 89.1759L39.3974 170.222C39.4853 170.924 39.9682 171.495 40.6707 171.67C41.9 171.934 43.8756 172.285 45.1927 172.548C45.8952 172.68 46.5537 172.109 46.5537 171.407L44.4024 92.9077C44.3585 91.3711 45.6318 90.0979 47.1684 90.1418C51.2953 90.2735 57.793 90.8443 61.2614 91.1955C62.6224 91.3272 63.676 92.4248 63.7199 93.7858L66.6615 172.724C67.7591 175.358 75.4422 174.875 75.4422 174.875C75.4422 174.875 83.1253 175.358 84.2228 172.724L87.1644 93.7858C87.2083 92.4248 88.2619 91.3272 89.6229 91.1955C93.0913 90.8443 99.5451 90.2735 103.716 90.1418C105.253 90.0979 106.526 91.3711 106.482 92.9077L104.331 171.407C104.331 172.109 104.945 172.68 105.692 172.548C107.009 172.329 108.94 171.978 110.214 171.67C110.916 171.495 111.399 170.924 111.487 170.222L120.136 89.1759C120.224 88.1662 120.926 87.332 121.892 86.9808L127.687 85.8393L128.873 72.9756L75.3543 76.0927Z",
    fill: "#BFD9FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M75.3535 76.0927V204.774C75.3535 204.774 110.169 206.574 117.457 195.817L128.696 72.9756C128.696 72.9756 85.0562 75.3903 75.3535 76.0927Z",
    fill: "#0851B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.643 63.971C138.643 63.971 133.102 67.3495 82.572 53.901C32.0875 40.2828 28.9777 34.5862 28.9777 34.5862C24.4555 39.4196 23.8819 43.7656 23.8819 43.7656C30.1529 54.6273 79.3789 65.8175 79.3789 65.8175C79.3789 65.8175 127.647 80.7509 138.467 74.4685C138.467 74.4685 140.154 70.3755 138.643 63.971Z",
    fill: "#72A1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7639 30.789C88.7639 30.789 64.6374 21.5971 28.9769 34.5862C28.9769 34.5862 31.57 41.8716 82.5711 53.901C132.765 68.9414 138.642 63.971 138.642 63.971C114.254 34.8919 88.7639 30.789 88.7639 30.789Z",
    fill: "#98C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.188 26.8358C103.276 25.996 102.949 25.1811 102.265 24.6797C98.564 21.8698 91.5493 20.3993 91.5493 20.3993C91.5493 20.3993 84.7392 18.1655 80.1288 18.7482C79.3283 18.8519 78.6376 19.394 78.252 20.1543L74.6906 28.0177L88.7654 30.7891L102.34 35.4264L103.188 26.8358Z",
    fill: "#72A1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_102663",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_102663",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CBD6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fa3e6b730b69bc2032296e9f380dbd0b.svg";
export { ForwardRef as ReactComponent };